// Content page specific styles

import $ from "jquery";

// Defer until launch
$(() => {
  $('.c-section-nav__link--top').click(function() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });
});



// WEBPACK FOOTER //
// ./src/frontend/common/content-page/content-page.js